var m = require('mithril');
var edit = require('../layout/components/edit');
var columnForm = require('../data/components/columnModal');
var Point = require('../data/models/point');
var isAggregatePoint = require('../data/isAggregatePoint');
var pointTrendModal = require('../data/components/pointTrendModal');

module.exports = {
  oninit: function (vnode) {
    this.column = vnode.attrs.column;
    this.parentReinitialize = vnode.attrs.parentReinitialize;
    this.link = vnode.attrs.link;
    this.disableInteractions = Boolean(vnode.attrs.disableInteractions);
  },
  view: function (vnode) {
    var boolBoxClasses = [];
    // Normalize booleans robustly. Use Point.readValue for point value, and a tolerant parser for flags.
    var value = Number(Point.readValue({ unit: 'bool', value: vnode.attrs.pointRecord.value })) === 1;
    var interactionsDisabled = Boolean(vnode.attrs.disableInteractions);
    var toBool = function (v) {
      if (typeof v === 'boolean') return v;
      if (v === null || typeof v === 'undefined') return false;
      if (typeof v === 'number') return v !== 0;
      if (typeof v === 'string') {
        var s = v.trim().toLowerCase();
        return s === '1' || s === 'true' || s === 'yes' || s === 'on';
      }
      return Boolean(v);
    };
    var reverseBoolean = toBool(vnode.attrs.pointRecord.alarmReverseBoolean);
    var alarmEnabled = toBool(vnode.attrs.pointRecord.alarmEnabled);
    var overrideActive = toBool(vnode.attrs.pointRecord.overrideActive);
    var alarmStatus = vnode.attrs.pointRecord.alarmStatus;
    var isTripped = alarmStatus === 'Alarm Tripped';

    // Background color: prefer explicit alarm status when available
    if (isTripped) {
      boolBoxClasses.push('bg-red');
    } else if (value) {
      // Non-tripped: show active state in blue
      boolBoxClasses.push('bg-blue');
    }

    if (overrideActive) {
      boolBoxClasses.push('b--yellow');
    } else if (alarmEnabled && reverseBoolean && !value) {
      // Only show red border for reverse-alarm condition on inactive value
      boolBoxClasses.push('b--red');
    } else {
      // Default border is blue (do not turn border red just because alarm is tripped)
      boolBoxClasses.push('b--blue');
    }

    // Preserve an explicit read-only action while blocking writes and edits.
    var hasClickFunction = typeof vnode.attrs.clickFunction === 'function';
    var defaultPointClick = this.column && !this.link
      ? function (event) {
          if (event && event.preventDefault) event.preventDefault();
          pointTrendModal.open(this.column);
        }.bind(this)
      : undefined;
    var cellClick = interactionsDisabled
      ? hasClickFunction
        ? vnode.attrs.clickFunction
        : function (e) { if (e && e.preventDefault) e.preventDefault(); }
      : edit.vm.editing() && this.column
        ? columnForm.editDialogue.bind(columnForm, this.column, { submitCallback: this.parentReinitialize })
        : vnode.attrs.clickFunction || defaultPointClick;

    var writable = !interactionsDisabled && !isAggregatePoint(this.column) && (this.column?.in?.writable || this.column?.in?.overrides);
    var anchorAttrs = interactionsDisabled && !hasClickFunction
      ? { href: undefined, style: { pointerEvents: 'none', cursor: 'default' } }
      : {
          href:
            typeof vnode.attrs.href !== 'undefined'
              ? vnode.attrs.href
              : this.column && !edit.vm.editing() && !this.link
              ? '#'
              : this.link
              ? '#!' + this.link
              : undefined,
          'aria-haspopup': vnode.attrs.href === '#' || defaultPointClick ? 'dialog' : undefined,
          title: vnode.attrs.href === '#' || defaultPointClick ? vnode.attrs.linkTitle || 'View trend chart' : undefined,
          'data-point-rid': vnode.attrs.pointRecord && vnode.attrs.pointRecord['@rid'],
        };

    return m(
      vnode.attrs.tdSelector || `td.pl1${vnode.attrs.tdClass ? vnode.attrs.tdClass : '.bb'}.nowrap`,
      { key: vnode.attrs.key, onclick: cellClick, style: vnode.attrs.tdStyle },
      [
        m(
          'a.f4' + (writable ? '.bb' : ''),
          anchorAttrs,
          [
            this.column?.in?.time && Date.now() - this.column.in.time < 3600000
              ? m(
                  'div.h1.w1.ba.' + boolBoxClasses.join('.'),
                  {
                    style: { backgroundClip: 'content-box', padding: '2px' },
                  },
                  [
                    m('div.bb.b--white', {
                      style: {
                        height: '60%',
                        marginLeft: '-2px',
                        marginRight: '-2px',
                        display:
                          Date.now() - vnode.attrs.pointRecord.time >
                          (vnode.attrs.pointRecord.interval || 60000)
                            ? 'block'
                            : 'none',
                      },
                    }),
                  ]
                )
              : m('div', ['---']),
          ]
        ),
      ]
    );
  },
};
